function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-832.189 -168.835)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M841.993,196.207a.918.918,0,0,1-.041-.261c.313-1.384-.456-1.891-1.635-2.323-2.438-.893-4.819-1.942-7.223-2.928-.181-.074-.355-.165-.583-.271l2.5-6.114.779.305-2.147,5.366,8.283,3.392V175.721h12.5l.042-.191-12.817-5.235-4.833,11.9-.832-.338,5.186-12.7c.736.3,1.433.571,2.127.854,4.4,1.8,8.8,3.6,13.213,5.38a4.366,4.366,0,0,0,1.479.286c1.329.039,2.66.013,4.02.013v3.9h-.826v-2.974H842.853v18.72h18.3V182.293H862v13.915Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M900.359,237.425V222.7h14.756v14.73Zm13.921-13.877H901.287v12.7l4.74-8.643,1.676,3.216-.778.358-.913-1.682-3.919,7.087c.956,0,1.775-.029,2.591.012a.824.824,0,0,0,.87-.53c1.413-2.595,2.852-5.175,4.286-7.758.115-.207.249-.4.41-.663l3.944,7.962.086-.046Zm-.6,13.035c-.661-1.347-1.272-2.62-1.919-3.874a.71.71,0,0,0-.523-.266c-.592-.033-1.187-.012-1.8-.012v-.906h1.746l-1.021-2.039-3.894,7.1Z",
  transform: "translate(-55.768 -44.003)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M993.741,233.005h.783v.813h-.783Z",
  transform: "translate(-132.524 -52.478)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M848.776,245.155l.785.321-.289.792-.8-.3Z",
  transform: "translate(-13.123 -62.465)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M957.631,234.088a1.657,1.657,0,0,1-1.63-1.673,1.658,1.658,0,1,1,1.63,1.673Zm0-.865a.765.765,0,0,0,.818-.788.782.782,0,0,0-1.563-.046A.762.762,0,0,0,957.627,233.223Z",
  transform: "translate(-101.504 -50.647)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}));

var SvgGallery = function SvgGallery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gallery",
    className: "fill-stroke",
    width: 30.072,
    height: 27.622,
    viewBox: "0 0 30.072 27.622",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGallery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gallery.af22c760.svg";
export { ForwardRef as ReactComponent };